import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

export interface IActionToastPayload {
  actionLabel: string;
}

/** Toast with an action button (e.g. "Undo"); used through SnackBarService.infoWithAction(). */
@Component({
  selector: '[action-toast-component]',
  standalone: true,
  template: `
    @if (options.closeButton) {
      <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    }
    <div class="action-toast">
      <div role="alert" [class]="options.messageClass">{{ message }}</div>
      <button type="button" class="action-toast__button" (click)="onAction($event)">
        {{ payload.actionLabel }}
      </button>
    </div>
  `,
  styles: `
    .action-toast {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .action-toast__button {
      flex-shrink: 0;
      padding: 0;
      border: 0;
      background: none;
      font-weight: 700;
      color: inherit;
      text-decoration: underline;
      cursor: pointer;
    }
  `,
  // Same animation as the default ngx-toastr toast (animations are not inherited).
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ActionToastComponent extends Toast<IActionToastPayload> {
  get payload(): IActionToastPayload {
    return this.options.payload;
  }

  onAction(event: Event): void {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    this.remove();
  }
}
